export default [
  {
    id: 0,
    short: 'sun',
    full: 'Sunday'
  },
  {
    id: 1,
    short: 'mon',
    full: 'Monday'
  },
  {
    id: 2,
    short: 'tue',
    full: 'Tuesday'
  },
  {
    id: 3,
    short: 'wed',
    full: 'Wednesday'
  },
  {
    id: 4,
    short: 'thu',
    full: 'Thursday'
  },
  {
    id: 5,
    short: 'fri',
    full: 'Friday'
  },
  {
    id: 6,
    short: 'sat',
    full: 'Saturday'
  }
]